import type { AgentHandoffChipMeta, AgentProjectRun } from "@/lib/agent-api"

/** Совпадает с AgentConversation::RUN_STALE_AFTER — дальше прогон считается оборванным. */
export const HANDOFF_RUN_STALE_AFTER_MS = 15 * 60 * 1000

/** Доска задач перечитывает карточки, когда скрытый прогон закончился. */
export const TASKS_HANDOFF_FINISHED_EVENT = "it2tv:tasks-handoff-finished"

export type HandoffChipState = "running" | "done" | "failed"

export function parseHandoffMeta(meta: Record<string, unknown> | undefined): AgentHandoffChipMeta | null {
  if (!meta || meta.kind !== "handoff") return null
  const surface = meta.surface
  if (
    surface !== "characters" &&
    surface !== "locations" &&
    surface !== "props" &&
    surface !== "shot" &&
    surface !== "tasks"
  ) {
    return null
  }
  if (typeof meta.target_conversation_id !== "number") return null
  return meta as AgentHandoffChipMeta
}

/**
 * Терминальный meta.status — правда этой плашки после finish!.
 * Несколько handoff делят один диалог специалиста: idle/failed прогона значит
 * «сейчас никто не выполняется», а не «эта плашка закончилась». Пока meta
 * running, плашка остаётся running. Протухший processing/cancel_requested
 * гасит очередь целиком — диалог завис, следующие задания тоже стоят.
 */
export function resolveHandoffChipState(
  meta: AgentHandoffChipMeta,
  run: AgentProjectRun | null,
  now: number,
): HandoffChipState {
  if (meta.status === "done") return "done"
  if (meta.status === "failed") return "failed"

  if (run && (run.status === "processing" || run.status === "cancel_requested")) {
    const startedAt = run.started_at ? Date.parse(run.started_at) : NaN
    if (Number.isFinite(startedAt) && now - startedAt > HANDOFF_RUN_STALE_AFTER_MS) return "failed"
  }

  return "running"
}
